import { render } from "./PrintTest.vue?vue&type=template&id=68a5c072&ts=true"
import script from "./PrintTest.vue?vue&type=script&lang=ts"
export * from "./PrintTest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__